export const getValidRequestedPathname = (pathname: string, id?: string) => {
    if(!id) {
        return pathname
    }
    if(isNaN(parseInt(pathname.split("/")[2]))) {
        return pathname.split("/").splice(2).join("/")
    } else {
        return "/"
    }
}

export const isHostIncludesRefferer = (host: string, referrer: string) => {
    return referrer.split("//")[1].startsWith(host);
}

export const getSearchParams = (url: string) => {
    return url.split("?")[1];
}